import React from 'react';
import { COLOR_BY_REQUEST_STATUS } from 'components/Requests/styles';
import { StyledAccordion } from 'containers/AmcDetailsPage/FollowUpMyRequestsTab/MyRequests/styles';
import RequestDetails from 'components/Requests/RequestDetails';

interface RequestsType {
  requests: {
    NUM_DECLMARATION: string;
    NOM_PRENOM_ASSURE: string;
    SORT: string;
    reasonReject: String;
    MONTANT_REGLE: number;
    FRAIS_ENGAGE: number;
    DATE_SURVENANCE: string;
    DATE_REGLEMENT: string;
    RIB: string;
    MODE_REGLEMENT: string;
    NUM_SINISTRE: string;
  }[];
  expanded: boolean | String;
  handleChange: Function;
  listIndex: Number;
  isLoading: boolean;
}

const AccordionSinistre = ({
  requests,
  listIndex,
  handleChange,
  expanded,
  isLoading,
}: RequestsType) => {
  const renderDetails = (item: any, index: Number) => {
    return (
      <RequestDetails
        request={item}
        isLoading={isLoading}
        expanded={expanded}
        index={`request-${listIndex}-item-${index}`}
      />
    );
  };
  return (
    <>
      {requests.map((item: any, index: Number) => (
        <StyledAccordion
          color={
            COLOR_BY_REQUEST_STATUS[item.SORT] ||
            COLOR_BY_REQUEST_STATUS.DEFAULT
          }
          aria-controls={`panel-content-${index}`}
          id={`panel-header-${index}`}
          data-testid={`request-item-${index}`}
          onChange={handleChange(
            `request-${listIndex}-item-${index}`,
            item.NUM_DECLMARATION,
          )}
          expanded={expanded === `request-${listIndex}-item-${index}`}
        >
          {renderDetails(item, index)}
        </StyledAccordion>
      ))}
    </>
  );
};

export default AccordionSinistre;
